import React, { useState } from 'react';
import { PlusIcon, TrashIcon } from '../../Icons';
import { normalizePropertyTags, getTagBadgeClass } from '../../../utils/propertyTagUtils';

interface PropertyTagsEditorProps {
  tags?: string[] | null;
  onChange: (tags: string[]) => void;
  idPrefix?: string;
}

export const PropertyTagsEditor: React.FC<PropertyTagsEditorProps> = ({
  tags = [],
  onChange,
  idPrefix = 'property-tags-editor',
}) => {
  const [inputVal, setInputVal] = useState('');
  const currentTags = Array.isArray(tags) ? tags : [];

  const handleAdd = () => {
    if (!inputVal.trim()) return;
    const added = normalizePropertyTags(inputVal);
    const updated = Array.from(new Set([...currentTags, ...added]));
    onChange(updated);
    setInputVal('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  const handleRemove = (idxToRemove: number) => {
    onChange(currentTags.filter((_, i) => i !== idxToRemove));
  };

  return (
    <div id={`${idPrefix}-container`} className="space-y-2 text-xs">
      <label className="font-bold text-gray-700 block">Etiquetas / Tags del Inmueble</label>
      <div className="flex gap-2">
        <input
          id={`${idPrefix}-input`}
          type="text"
          value={inputVal}
          onChange={(e) => setInputVal(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Escribe una etiqueta y presiona Enter o +"
          className="flex-grow p-2 border rounded-lg focus:ring-sky-500 outline-none"
        />
        <button
          id={`${idPrefix}-add-btn`}
          type="button"
          onClick={handleAdd}
          className="px-3 py-1 bg-sky-600 hover:bg-sky-700 text-white rounded-lg font-bold flex items-center justify-center transition-colors"
        >
          <PlusIcon className="w-4 h-4" />
        </button>
      </div>

      <div id={`${idPrefix}-tags-list`} className="flex flex-wrap gap-1.5 min-h-[36px] p-2 bg-gray-50 rounded-lg border border-gray-100">
        {currentTags.length === 0 ? (
          <span className="text-gray-400 italic text-[11px] self-center">No hay tags asignados</span>
        ) : (
          currentTags.map((tag, idx) => (
            <span
              key={`${tag}-${idx}`}
              id={`${idPrefix}-tag-${idx}`}
              className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-bold border shadow-2xs ${getTagBadgeClass(tag, idx)}`}
            >
              <span>#{tag}</span>
              <button
                type="button"
                onClick={() => handleRemove(idx)}
                className="opacity-70 hover:opacity-100 hover:text-red-600 transition-opacity"
                title="Eliminar tag"
              >
                <TrashIcon className="w-3 h-3" />
              </button>
            </span>
          ))
        )}
      </div>
    </div>
  );
};
